
import React from 'react';
import { motion } from 'framer-motion';

interface Message {
  id: string;
  type: 'bot' | 'user';
  content: string;
  timestamp: Date;
}

interface ChatMessageProps {
  message: Message;
}

const ChatMessage = ({ message }: ChatMessageProps) => {
  const isBot = message.type === 'bot';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={`flex ${isBot ? 'justify-start' : 'justify-end'}`}
    >
      <div className={`max-w-[80%] ${isBot ? 'order-1' : 'order-2'}`}>
        {isBot && (
          <div className="flex items-center mb-2">
            <div className="w-8 h-8 bg-uplivion-blue rounded-full flex items-center justify-center mr-2">
              <span className="text-white text-sm font-medium">AI</span>
            </div>
            <span className="text-xs text-gray-500">Uplivion Assistant</span>
          </div>
        )}
        
        <div
          className={`p-3 rounded-2xl ${
            isBot
              ? 'bg-white/60 backdrop-blur-sm border border-white/30 text-gray-800'
              : 'bg-uplivion-blue text-white ml-auto'
          }`}
        >
          <p className="text-sm leading-relaxed whitespace-pre-wrap">
            {message.content}
          </p>
        </div>
        
        <div className={`text-xs text-gray-500 mt-1 ${isBot ? 'text-left' : 'text-right'}`}>
          {message.timestamp.toLocaleTimeString([], { 
            hour: '2-digit', 
            minute: '2-digit' 
          })}
        </div>
      </div>
    </motion.div>
  );
};

export default ChatMessage;
